import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import React, { useState } from "react";

interface Props {
  name: string;
  label: React.ReactNode;
  value?: string | number;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export const PasswordInput = (props: Props) => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div className="input_field">
      {/* Was hardcoded to id="password" regardless of props.name - harmless on the login form
          (whose only PasswordInput is actually named "password"), but silently pointed at a
          nonexistent id on SetPasswordForm's "confirm_password" field. */}
      <label htmlFor={props.name}>{props.label}</label>
      <div className="field">
        <input
          type={showPassword ? "text" : "password"}
          name={props.name}
          value={props.value}
          onChange={props.onChange}
          id={props.name}
          className="password_input"
        />
        <button
          type="button"
          className="password_toggle_button"
          onClick={() => setShowPassword((previous) => !previous)}
          aria-label={showPassword ? "Hide password" : "Show password"}
          data-test-id={`${props.name}-toggle-visibility`}
        >
          {showPassword ? <VisibilityOffIcon fontSize="small" /> : <VisibilityIcon fontSize="small" />}
        </button>
      </div>
    </div>
  );
};
